import { sidebarOptions, type TSidebarOption } from "@/zapi-frontend/stores/projectSidebarStore";

export type TChapterTool = TSidebarOption & { count?: number };

export function getChapterTools({ commentCount }: { commentCount: number }) {
  return sidebarOptions
    .filter((option) => option.value === "comments")
    .map((option): TChapterTool => (commentCount > 0 ? { ...option, count: commentCount } : option));
}
